export const DOWNLOAD_LINKS = {
  APP_STORE: 'https://apple.co/3C4IliB',
  PLAY_STORE: 'https://bit.ly/appFaks',
};

export const LGO_LINKS = {
  INTERCOM: 'https://intercom.help/faks/fr/articles/7984665-connexion-lgo',
  ONBOARDINGS: {
    ospharm: 'https://bienvenue.ospharm.org/8',
    offisante: 'https://offisante.fr/',
    santestat: 'https://www.santestat.fr/',
  },
};

export const INTERCOM_ARTICLES_LINKS = {
  COMPENSATIONS:
    'https://intercom.help/faks/fr/articles/16041795-comprendre-le-module-compensation',
  TRADE_PAYMENT:
    'https://intercom.help/faks/fr/articles/7120417-comment-fonctionne-le-paiement-de-mes-operations-sur-faks',
  STRIPE_CONFIG:
    'https://intercom.help/faks/fr/articles/7203127-comment-parametrer-mon-compte-stripe-pour-etre-paye-de-mes-operations',
  KONNECT_ONBOARDING:
    'https://intercom.help/faks/fr/articles/13409846-ou-se-trouve-faks-konnect-et-comment-l-activer',
};

export const TERMS_AND_CONDITIONS_URL = 'https://www.faks.co/conditions-generales-de-services';

export const PRIVACY_POLICY_URL = 'https://www.faks.co/politique-de-confidentialite';

export const LAB_DEMO_URL = 'https://www.faks.co/demande-de-demo-laboratoire';

export const KONNECT_DEMO_URL =
  'https://meetings-eu1.hubspot.com/oscar-lefebvre/demo-konnect-direct-pharma-';

export const ospharmWelcomeLink = (cip: string | null) =>
  cip ? `https://bienvenue.ospharm.org/8/${cip}` : 'https://bienvenue.ospharm.org/8';

export const openInNewTab = (link: string) => window.open(link, '_blank');

export const getAdminUserPageFullLink = (user_id: number) =>
  `${window.location.origin}/admin/users/${user_id}`;
